var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ScreenService } from '@ibe/services/ui';
import { Store } from "@ngrx/store";
import * as fromStore from "../../../../store";
import { takeWhile } from "rxjs/operators";
import { INDRAAirportLocationService } from '@ibe.services/airport-location.indra.service';
import { SESSION_VAR_KEY_LANGUAGE, SESSION_VAR_KEY_MARKET, DEFAULT_LANGUAGE, DEFAULT_MARKET } from '@ibe.config';
var INDRAFlightExploreDestinationsComponent = /** @class */ (function () {
    function INDRAFlightExploreDestinationsComponent(sanitizer, screen, airportLocationService, store) {
        var _this = this;
        this.sanitizer = sanitizer;
        this.screen = screen;
        this.airportLocationService = airportLocationService;
        this.store = store;
        this.searchRoute$ = this.store.select(fromStore.getMiniIBESearchRoutes);
        this.totalDestinations = 0;
        this.display_limit = 5;
        this.url = 'assets/images/plane.png';
        this.otherBookingTypes = [
            {
                id: 'rent-a-car',
                label: 'Rent-a-car',
                icon: 'icons.svg#services--rent_a_car',
                url: 'https://cars.flytap.com',
                aria: 'Open a new window to rent a car'
            },
            {
                id: 'transfer',
                label: 'Book a transfer',
                icon: 'icons.svg#transportation--bus',
                url: 'https://transport.flytap.com',
                aria: 'Open a new window to book a transfer'
            },
            {
                id: 'hotel',
                label: 'Book an hotel',
                icon: 'icons.svg#services--book_hotel',
                url: 'https://hotels.flytap.com',
                aria: 'Open a new window to book an hotel'
            },
            {
                id: 'parking',
                label: 'Parking',
                icon: 'icons.svg#services--parking',
                url: 'https://parking.flytap.com',
                aria: 'Open a new window to book a parking space'
            },
            {
                id: 'tours-and-activities',
                label: 'Tours & Activities',
                icon: 'icons.svg#destinations--tours_activities',
                url: 'http://atividades.flytap.com/',
                aria: 'Open a new window to search for tours and other activities'
            }
        ];
        this.allOtherBookingTypes = {
            id: 'all-booking-options',
            label: 'All booking options',
            url: 'https://www.flytap.com/outras-reservas',
            aria: 'Open a new window to view all other booking options'
        };
        this.bestOffers = {
            location: {
                city: ''
            },
            offers: [
                {
                    title: 'São Miguel',
                    label: 'from 12 EUR',
                    image: 'PDL'
                },
                {
                    title: 'Barcelona',
                    label: 'from 45 EUR',
                    image: 'BCN'
                },
                {
                    title: 'Paris',
                    label: 'from 34 EUR',
                    image: 'PAR'
                },
                {
                    title: 'Rome',
                    label: 'from 80 EUR',
                    image: 'ROM'
                },
                {
                    title: 'Marrakech',
                    label: 'from 311 EUR',
                    image: 'RAK'
                }
            ]
        };
        this.block_flights_to_city = [
            {
                city: 'Europe',
                flights: [
                    { image: './assets/images/destinations/banner/AMS.jpg', city: 'Funchal', price: 12, type: 'roundtrip' },
                    { image: './assets/images/destinations/banner/BCN.jpg', city: 'Madrid', price: 12, type: 'oneway' },
                    { image: './assets/images/destinations/banner/CHI.jpg', city: 'Berlin', price: 12, type: 'roudntrip' },
                    { image: './assets/images/destinations/banner/FNC.jpg', city: 'Rome', price: 12, type: 'roudntrip' }
                ]
            },
            {
                city: 'Noth America',
                flights: [
                    { image: './assets/images/destinations/banner/HAM.jpg', city: 'Boston', price: 12, type: 'roudntrip' },
                    { image: './assets/images/destinations/banner/LIS.jpg', city: 'Toronto', price: 12, type: 'oneway' },
                    { image: './assets/images/destinations/banner/MAD.jpg', city: 'Miami', price: 12, type: 'oneway' },
                    { image: './assets/images/destinations/banner/OPO.jpg', city: 'Prague', price: 12, type: 'roudntrip' }
                ]
            },
            {
                city: 'South America',
                flights: [
                    { image: './assets/images/destinations/banner/PAR.jpg', city: 'Prague', price: 12, type: 'oneway' },
                    { image: './assets/images/destinations/banner/RIO.jpg', city: 'Prague', price: 12, type: 'roudntrip' },
                    { image: './assets/images/destinations/banner/ROM.jpg', city: 'Prague', price: 12, type: 'oneway' },
                    { image: './assets/images/destinations/banner/SAO.jpg', city: 'Prague', price: 12, type: 'roudntrip' }
                ]
            },
            {
                city: 'Africa',
                flights: [
                    { image: './assets/images/destinations/banner/MAD.jpg', city: 'Prague', price: 12, type: 'roudntrip' },
                    { image: './assets/images/destinations/banner/LIS.jpg', city: 'Prague', price: 12, type: 'roudntrip' },
                    { image: './assets/images/destinations/banner/HAM.jpg', city: 'Prague', price: 12, type: 'roudntrip' },
                    { image: './assets/images/destinations/banner/AMS.jpg', city: 'Prague', price: 12, type: 'oneway' }
                ]
            }
        ];
        this.airportParams = {
            language: sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
                sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) : DEFAULT_LANGUAGE,
            market: sessionStorage.getItem(SESSION_VAR_KEY_MARKET) ?
                sessionStorage.getItem(SESSION_VAR_KEY_MARKET) : DEFAULT_MARKET,
            country: '',
        };
        this.continentsParams = {
            language: sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
                sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) : DEFAULT_LANGUAGE,
            market: sessionStorage.getItem(SESSION_VAR_KEY_MARKET) ?
                sessionStorage.getItem(SESSION_VAR_KEY_MARKET) : DEFAULT_MARKET,
        };
        this.continents = [];
        this.isMobile = false;
        this.regions = [];
        this.selectedCountryCode = null;
        this.countries = [];
        this.newRegions = [];
        this.airports = [];
        this.isAlive = true;
        this.getDestinationsFlag = false;
        this.previousAirportCode = '';
        this.isScreenMobileTabletPortrait$ = this.store.select(fromStore.isScreenMobileTabletPortrait);
        this.isScreenMobileTabletPortrait$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.isScreenMobileTabletPortrait = value;
        });
    }
    INDRAFlightExploreDestinationsComponent.prototype.ngOnInit = function () {
        var _this = this;
        var continentsParams = Object.keys(this.continentsParams).map(function (key) { return key + '=' + _this.continentsParams[key]; }).join('&');
        this.airportLocationService.INDRAGetContinents(continentsParams).toPromise().then(function (response) { return __awaiter(_this, void 0, void 0, function () {
            var i, region;
            return __generator(this, function (_a) {
                this.regions = [];
                this.countries = [];
                this.places = [];
                this.newRegions = [];
                if (response) {
                    this.regions = response.Continents;
                    if (this.regions) {
                        for (i = 0; i < this.regions.length; i++) {
                            region = {
                                'label': this.regions[i].name,
                                'value': this.regions[i].name,
                                'code': this.regions[i].code
                            };
                            this.newRegions.push(region);
                            region = null;
                        }
                        this.continents = this.newRegions;
                        this.selected_destinations = this.continents[0].label;
                        this.INDRA_setPutDestination(this.selected_destinations);
                        this.destinations = this.continents;
                    }
                }
                return [2 /*return*/];
            });
        }); });
    };
    INDRAFlightExploreDestinationsComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    INDRAFlightExploreDestinationsComponent.prototype.INDRA_getPlaneImage = function () {
        var url = 'assets/images/plane.png';
        return this.sanitizer.bypassSecurityTrustUrl(url);
    };
    // TODO: implement this to compute the total number of destinations/airports to display
    INDRAFlightExploreDestinationsComponent.prototype.INDRA_setDestinationsCount = function () {
        //this.continents.forEach(continent => {
        //	continent.countrys.forEach(country => {
        //		this.totalDestinations += country.places.length;
        //	});
        //});
    };
    INDRAFlightExploreDestinationsComponent.prototype.INDRA_getCountrysDestinations = function () {
        return __awaiter(this, void 0, void 0, function () {
            var country_limit, regionIdx, j, airportString, country;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        country_limit = this.display_limit;
                        this.region = this.selected_destinations;
                        regionIdx = this.regions.findIndex(function (x) { return x.name === _this.region; });
                        if (!(this.regions && this.regions[regionIdx].countries && this.regions[regionIdx].countries.length !== 0)) return [3 /*break*/, 4];
                        this.countries = [];
                        j = 0;
                        _a.label = 1;
                    case 1:
                        if (!(j < country_limit)) return [3 /*break*/, 4];
                        this.airportParams.country = this.regions[regionIdx].countries[j].code;
                        airportString = Object.keys(this.airportParams).map(function (key) { return key + '=' + _this.airportParams[key]; }).join('&');
                        return [4 /*yield*/, this.airportLocationService.INDRAGetAirports(airportString).toPromise().then(function (result) {
                                if (result) {
                                    _this.places = [];
                                    for (var k = 0; k < result.airports.length; k++) {
                                        var place = {
                                            'label': result.airports[k].cityName
                                        };
                                        _this.places.push(place);
                                    }
                                }
                            })];
                    case 2:
                        _a.sent();
                        this.places = this.places.length > 5 ? this.places.slice(0, this.display_limit) : this.places;
                        country = {
                            'label': this.regions[regionIdx].countries[j].name,
                            'places': this.places
                        };
                        if (this.places.length === 0) {
                            this.display_limit = this.display_limit - 1;
                        }
                        else {
                            this.countries.push(country);
                        }
                        while (this.display_limit == this.countries.length) {
                            this.countries = this.countries.length > 5 ? this.countries.slice(0, this.display_limit) : this.countries;
                            this.airportsPerCountry = this.countries;
                            this.loading = false;
                            this.display_limit = 5;
                            return [2 /*return*/, this.airportsPerCountry];
                        }
                        _a.label = 3;
                    case 3:
                        j++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    INDRAFlightExploreDestinationsComponent.prototype.INDRA_setPutDestination = function (event) {
        this.loading = true;
        this.selected_destinations = event;
        this.INDRA_getCountrysDestinations();
    };
    return INDRAFlightExploreDestinationsComponent;
}());
export { INDRAFlightExploreDestinationsComponent };
